import {createContext, type ReactNode, use} from 'react'

export interface ModalContextValue {
	openModal: (content: ReactNode) => void
	closeModal: () => void
	loading: boolean
	setLoading: (loading: boolean) => void
}

export const ModalContext = createContext<ModalContextValue | null>(null)

export function useModal() {
	const context = use(ModalContext)
	if (!context) {
		throw new Error('useModal must be used within a ModalProvider')
	}
	return context
}
